import axios from 'axios';
import { getAuth } from './dev-auth';
import { requestInterceptor } from './interceptors/interceptors';

// Resolve API base path from the same source of truth that src/index.tsx uses to
// pick React Router's basename: PRELOADED_BLAZE_USER_CONFIG.config.isPrivateCloudRequest.
// Under Private Cloud the SPA is mounted at `/mock/`, so the API lives at
// `/mock/api/v1`; otherwise it's `/api/v1`. We deliberately do NOT use
// `document.baseURI` — without a <base> tag it equals the current document URL,
// so deep SPA routes (e.g. `/mock-services/123`) would corrupt the joined path
// via naive string concatenation.
const preload = typeof PRELOADED_BLAZE_USER_CONFIG !== 'undefined' ? PRELOADED_BLAZE_USER_CONFIG : null;
const isPrivateCloud = !!(preload && preload.config && preload.config.isPrivateCloudRequest);
const baseUrl = isPrivateCloud ? '/mock/api/v1' : '/api/v1';

const instance = axios.create({
  baseURL: baseUrl,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  auth: getAuth(),
});

// Enable forward of xsrf token
// https://stackoverflow.com/questions/69002516/axios-not-sending-xsrf-token-with-headers
instance.defaults.withXSRFToken = true;

//Request interceptor
instance.interceptors.request.use(
  request => {
    return requestInterceptor(request);
  },
  error => {
    return Promise.reject(error);
  },
);

//HTTP interceptor for response errors
instance.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    console.log(error);
    console.log('Error while fetching resource: ' + error.message);
    return Promise.reject(error);
  },
);

export default instance;
